import React from "react";
import { Facebook, Linkedin, Instagram, Twitter } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { footer } from "../mock";

/* Map footer link labels to internal routes */
const FOOTER_ROUTES = {
  "Investors": "/investors#main-content",
  "FAQ": "/faq",
  "Terms & Conditions": "/terms",
  "Privacy Policy": "/privacy-policy",
};

/* Map footer link labels to external URLs */
const FOOTER_EXTERNAL = {
  "Zipexpress Delivery": "https://zipexpress.co",
  "Cyrus Field Technologies": "https://cyrusfieldtech.com",
  "Kanal Platform and Software": "https://kanal.cyrusfieldtech.com",
};

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#111111] text-white pt-14 pb-8">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-1">
            <Logo textClass="text-white" />
            <div className="flex gap-3 mt-5">
              {[
                { Icon: Facebook, href: "https://www.facebook.com/KYoOwn1", label: "Facebook" },
                { Icon: Linkedin, href: "https://www.linkedin.com/company/kyo-group-limited/", label: "LinkedIn" },
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Twitter, href: "#", label: "Twitter" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  onClick={href === "#" ? (e) => e.preventDefault() : undefined}
                  target={href !== "#" ? "_blank" : undefined}
                  rel={href !== "#" ? "noreferrer" : undefined}
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ED2E24] flex items-center justify-center transition-colors"
                  aria-label={label}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {footer.columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-[15px] font-semibold mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => {
                  const route = FOOTER_ROUTES[link];
                  const external = FOOTER_EXTERNAL[link];
                  return (
                    <li key={link}>
                      {route ? (
                        <button
                          onClick={() => { navigate(route); window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }}
                          className="text-[13px] text-gray-400 hover:text-[#ED2E24] transition-colors text-left"
                          data-testid={`footer-link-${link.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                          {link}
                        </button>
                      ) : external ? (
                        <a
                          href={external}
                          target="_blank"
                          rel="noreferrer"
                          className="text-[13px] text-gray-400 hover:text-[#ED2E24] transition-colors"
                          data-testid={`footer-link-${link.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                          {link}
                        </a>
                      ) : (
                        <a
                          href="#"
                          onClick={(e) => e.preventDefault()}
                          className="text-[13px] text-gray-400 hover:text-[#ED2E24] transition-colors"
                        >
                          {link}
                        </a>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center space-y-1">
          <p className="text-[12px] text-gray-400">{footer.address}</p>
          <p className="text-[12px] text-gray-400">{footer.copyright}</p>
          <p className="text-[12px] text-gray-500">{footer.powered}</p>
        </div>
      </div>
    </footer>
  );
}
